<div class="container-options">
    <!--    <div class="">-->
    <!--        <mat-checkbox (change)="onSelectAllChange($event)">Sélectionner Tout</mat-checkbox>-->
    <!--    </div>-->

    <!--    <mat-divider></mat-divider>-->

    <div class="search-container">
        <div
                class="tv-round-input-extensible-no-label full-width"
                [ngClass]="{'fade-in-right': panelOpened, 'fade-out-left': !panelOpened}">
            <mat-form-field>
                <mat-icon matPrefix class="small-icon">search</mat-icon>
                <input matInput
                       [formControl]="searchFormControl"
                       [matAutocomplete]="auto"
                       name="search"/>

                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar" #auto="matAutocomplete"
                                  [displayWith]="displayItem">
                    <mat-option *ngFor="let item of filteredItemList$ | async" class="tv-ns-select-option"
                                [value]="item">
                        {{ item.name }} ({{ item.id}})
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <!-- Repartition Check-->
    <div class="bloc-container-share">
        <div class="red-title-container">
            <h4 class="red-title">Poids total répartition : </h4>
            <div class="red-info-container">
                <mat-icon
                        *ngIf="selectedOptions.size > 0 && getTotalSelectedRepartition() > 100"
                        class="red-icon"
                        matTooltip="Le total de la répartition doit être égal à 100%"
                        matTooltipPosition="above"
                >
                    error
                </mat-icon>
                <span class="red-title"> {{ getTotalSelectedRepartition() }} %</span>
            </div>
        </div>
    </div>

    <!-- Channel Items -->
    <div *ngIf="!isLoadingItemList" class="checkbox-list tv-custom-always-visible-scroll-bar">
        <ng-container *ngIf="(data.itemList | async) as items">
            <div *ngFor="let item of items; let i = index" class="checkbox-input">
                <div class="channel-info">
                    <mat-checkbox class="tv-blueish-grey-checkbox" [checked]="isOptionSelected(item)" (change)="onOptionChange($event, item, i)">
                    </mat-checkbox>
                    <img class="channel-logo" [src]="item.channel.logo" alt="logo"/>
                    <span class="channel-name">{{ item.channel.name }}</span>
                </div>
                <div class="rate-cell">
                    <div class="rate-input-group">
                        <div class="tv-rect-input-small-no-label width-120px">
                            <mat-form-field>
                                <input
                                        type="number"
                                        aria-label="Number"
                                        minlength="1" maxlength="3"
                                        matInput
                                        [formControl]="getRateFormControl(i)"
                                        (change)="onRateChange($event, item, i)"
                                />
                            </mat-form-field>
                        </div>
                        <div class="tv-input-error-message" *ngIf="getRateFormControl(i).touched && getRateFormControl(i).hasError('required')">
                            <mat-icon class="tv-input-error-icon">error</mat-icon>
                            <span class="tv-input-error-text">Veuillez saisir une valeur</span>
                        </div>
                        <div class="tv-input-error-message" *ngIf="getRateFormControl(i).touched && getRateFormControl(i).hasError('min')">
                            <mat-icon class="tv-input-error-icon">error</mat-icon>
                            <span class="tv-input-error-text">Supérieure à 0</span>
                        </div>
                        <div class="tv-input-error-message" *ngIf="getRateFormControl(i).touched && getRateFormControl(i).hasError('max')">
                            <mat-icon class="tv-input-error-icon">error</mat-icon>
                            <span class="tv-input-error-text">Inférieure ou égale à 100</span>
                        </div>
                    </div>
                    <div class="rate-unit">%</div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="button-edit">
        <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelSelectClick()">Annuler
        </button>
        <button class="tv-ns-validation-large-button" (click)="onSaveChosenItemList()">Valider</button>
    </div>
</div>
